module.exports = __webpack_public_path__ + "img/effectivity-module.7c149b7f.png";